
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 33 35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1623_12049)","fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M3.67 9.552h4.85c1.532 6.559 6.982 11.372 7.003 11.388l.466.42.466-.415c.02-.015 5.59-4.865 7.267-11.393h5.295c.663 0 1.211.492 1.289 1.15l2.604 22.164c.046.383-.063.73-.321 1.014-.254.29-.585.435-.973.435H1.294c-.383 0-.71-.145-.968-.43A1.264 1.264 0 010 32.877l2.365-22.164a1.297 1.297 0 011.294-1.16h.01zm6.294 0h12.309c-1.351 4.82-4.98 8.65-6.28 9.902-1.273-1.252-4.797-5.057-6.03-9.902z","fill":"#0E6199"}}),_c('path',{attrs:{"d":"M15.937 19.413s-6.465-5.74-6.48-12.899C9.45 2.466 12.773.002 15.987.002c4.017-.005 6.786 2.925 6.724 6.465-.13 7.128-6.78 12.946-6.78 12.946h.005z","fill":"#0E6199"}}),_c('path',{attrs:{"d":"M15.616 19.113a48.76 48.76 0 00.098-3.158c0-5.631-.932-10.885-2.536-15.316-2.091.973-3.727 3.033-3.722 5.88.01 6.201 4.86 11.33 6.16 12.6v-.006z","fill":"#136FAD"}}),_c('path',{attrs:{"d":"M11.91 34.315c1.802-3.773 3.065-8.37 3.567-13.416-.528-.477-5.503-5.125-6.957-11.347H3.67c-.668 0-1.222.497-1.294 1.16L.01 32.876a1.27 1.27 0 00.326 1.01c.254.284.585.43.968.43H11.91zm3.712-15.238c.062-1.025.098-2.07.098-3.127 0-2.2-.14-4.343-.409-6.398H9.964c1.128 4.431 4.177 7.992 5.663 9.525h-.005z","fill":"#136FAD"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1623_12049"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h32.926v34.318H0z"}})])])])
          )
        }
      }
    